import React, { useEffect, useRef, useState } from "react";
import "./task.css";
// import playacard from "../../assets/Task/pickacard.png";
// import quizImg from "../../assets/Task/Quiz.png";
// import wordscrambleImg from "../../assets/Task/word-scramble.png";
// import games from "../../assets/images/games.png";
import useUserInfo from "../../Hooks/useUserInfo";
import PickaWord from "./PickaWord/PickaWord";
import quiz from "./QuizTask/QuizTask";
import scramble from "./ScrambleaWord/ScrambleaWord";
import cancelIcon from "../../assets/Task/cancelicon.svg";
import Tv from "../Tv/Tv";
import { getUserDetails1 } from "../../apis/user";
import { useAudio } from "../../Providers/AudioProvider";
import { logPageView } from "../../components/analytics";
import { gamesList } from "../../helpers/helpers";
import matchmeme from "./matchmeme/matchmeme";
import breakmeme from "./breakmeme/breakmeme";
import tictactoe from "./tictactoe/tictactoe";
import twenty from "./2048/games2048.js";
import Snake from "./snake/snake.js";
// // import flappy from "../../Pages/Tv/Iplbattle/chooseteam.js";
// import flappy from "../../Pages/Tv/Iplbattle/matchscedule.js";
// import flappy from "../Tv/Iplbattle/selectTeamCard.js";
import Puzzle from "./puzzle/puzzle.js";
import Quento from "./quento/quento.js";
// import Connectfour from "./Connectfour/Connectfour.jsx";
import battle from "../Tv/Iplbattle/ipllanding.js";
import MatchScheduleList from "../Tv/Iplbattle/matchsceduleList.js";
import CricketTask from "./Cricket/Cricket.js";
import Flappy from "./Flappy/flappy.js";
import WhackAMole from "./whack-a-mole/whackamole.jsx";
import Connectfour from "./Connectfour/Connectfour.jsx";
import rockpaperscissors from "./rps/rockpaperscissors.jsx";
import DinoGame from "./dino/dino.jsx";
import MemeCandy from "./candy/MemeCandy.js";
import Hangman from "./hangman/hangman.jsx";
import RainbowConnect from "./quento/rainbow/rainbow.js";
import Minesweeper from "./minesweeper/minesweeper.js";
import spaceinvader from "./spaceinvader/spaceinvader.js";
import Simonsays from "./simonsays/Simonsays.jsx";
import Web3Quiz from "./Quiz-Game/Web3Quiz.js";
import tetris from "./tetris/tetris.js";
import JumpingOrbits from "./jumpingorbits/jumpingorbits.js";
import Stacker from "./Stacked/Stacker.js";
import FruitSlice from "./fruitslice/FruitSlice";
import CarRace from "./cargame/CarRace";
import MarioJump from "./mario/src/MarioJump.js";
import TicTacToeWeb from "./Multi-Player-Tic-Tac/tictactoeWeb.js";
import Racing from "./Racing/index.js";
// import BeachyballWrapper from "./beachyball/src/beach.jsx";
import ChessGame from "./chess/chess.js";
import ChessGameWeb from "./chess/chessWeb.js";
import ConnectFourWeb from "./Connectfour/ConnectfourWeb.jsx";
import SnakeAndLadder from "./SnakeLadder/SnakeAndLadder.js";
import UnoGame from "./UnoGame/UnoGame.jsx";
const Task = () => {
  const gamesData = gamesList;
  const playClick = useAudio();
  const scrollContainerRef = useRef(null);
  const [touchStartY, setTouchStartY] = useState(0);
  const [scrollTop, setScrollTop] = useState(0);
  const gameRefMap = {
    quiz: { component: quiz, label: "quiz" },
    scramble: { component: scramble, label: "scramble" },
    Pickaword: { component: PickaWord, label: "PickaWord" },
    matchmeme: { component: matchmeme, label: "matchmeme" },
    tictactoe: { component: tictactoe, label: "tictactoe" },
    twenty: { component: twenty, label: "twenty" },
    Snake: { component: Snake, label: "Snake" },
    breakmeme: { component: breakmeme, label: "breakmeme" },
    cricket: { component: CricketTask, label: "CricketTask" },
    Flappy: { component: Flappy, label: "Flappy" },
    puzzle: { component: Puzzle, label: "puzzle" },
    quento: { component: Quento, label: "quento" },
    WhackAMole: { component: WhackAMole, label: "WhackAMole" },
    Connectfour: { component: Connectfour, label: "Connectfour" },
    rockpaperscissors: {
      component: rockpaperscissors,
      label: "rockpaperscissors",
    },
    dino: { component: DinoGame, label: "DinoGame" },
    MemeCandy: { component: MemeCandy, label: "MemeCandy" },
    hangman: { component: Hangman, label: "Hangman" },
    RainbowConnect: { component: RainbowConnect, label: "RainbowConnect" },
    Simonsays: { component: Simonsays, label: "Simonsays" },
    Web3Quiz: { component: Web3Quiz, label: "Web3Quiz" },
    Minesweeper: { component: Minesweeper, label: "Minesweeper" },
    spaceinvader: { component: spaceinvader, label: "spaceinvader" },
    tetris: { component: tetris, label: "tetris" },
    jumpingorbits: { component: JumpingOrbits, label: "jumpingorbits" },
    stacker: { component: Stacker, label: "stacker" },
    fruitslice: { component: FruitSlice, label: "FruitSlice" },
    CarRace: { component: CarRace, label: "CarRace" },
    TicTacToeWeb: { component: TicTacToeWeb, label: "TicTacToeWeb" },
    MarioJump: { component: MarioJump, label: "MarioJump" },
    TicTacToeWeb: { component: TicTacToeWeb, label: "TicTacToeWeb" },
    Racing: { component: Racing, label: "Racing" },
    // BeachyBall: { component: BeachyballWrapper, label: "BeachyBall" },
    Chess: { component: ChessGame, label: "Chess" },
    ChessWeb: { component: ChessGameWeb, label: "ChessWeb" },
    ConnectFourWeb: { component: ConnectFourWeb, label: "ConnectFourWeb" },
    SnakeLadder: { component: SnakeAndLadder, label: "SnakeLadder" },
    UnoGame: { component: UnoGame, label: "UnoGame" },
  };
  // Add touch event handlers for manual scrolling
  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;
    const handleTouchStart = (e) => {
      setTouchStartY(e.touches[0].clientY);
      setScrollTop(scrollContainer.scrollTop);
    };
    const handleTouchMove = (e) => {
      if (!touchStartY) return;
      const touchY = e.touches[0].clientY;
      const diff = touchStartY - touchY;
      // Apply the scroll
      scrollContainer.scrollTop = scrollTop + diff;
      // Prevent default to avoid any native scrolling
      e.preventDefault();
    };
    const handleTouchEnd = () => {
      setTouchStartY(0);
    };
    // Add event listeners
    scrollContainer.addEventListener("touchstart", handleTouchStart, {
      passive: false,
    });
    scrollContainer.addEventListener("touchmove", handleTouchMove, {
      passive: false,
    });
    scrollContainer.addEventListener("touchend", handleTouchEnd, {
      passive: false,
    });
    return () => {
      // Clean up event listeners
      scrollContainer.removeEventListener("touchstart", handleTouchStart);
      scrollContainer.removeEventListener("touchmove", handleTouchMove);
      scrollContainer.removeEventListener("touchend", handleTouchEnd);
    };
  }, [touchStartY, scrollTop]);
  useEffect(() => {
    updateUserInfo((prev) => ({
      ...prev,
      isLoading: false,
    }));
  }, []);
  const { watchScreen, userDetails, updateUserInfo, updatewatchScreenInfo } =
    useUserInfo();
  const goToThePage = (component, name) => {
    playClick();
    updateUserInfo((prev) => {
      return {
        ...prev,
        ...{
          currentComponent: component,
          currentComponentText: name,
          lastComponent: userDetails.currentComponent,
          lastComponentText: userDetails.currentComponentText,
          isMenu: false,
        },
      };
    });
  };
  const reclaimUserDetails = () => {
    if (!watchScreen.booster) {
      const data = getUserDetailsOnly().then(() => {
        goToThePage(Tv, "TVPage");
        // goToThePage(Battle, "BattlePage");
      });
    } else {
      goToThePage(Tv, "TVPage");
    }
  };
  useEffect(() => {
    logPageView("TaskPage", "Task page");
  }, []);
  const getUserDetailsOnly = async () => {
    let userDetails1;
    try {
      userDetails1 = await getUserDetails1(
        userDetails?.userDetails?.telegramId
      );
    } catch (error) {
      console.error("Error in updating or fetching user details:", error);
    }
    // Update state after both async calls are completed
    if (userDetails) {
      updateUserInfo((prev) => ({
        ...prev,
        userDetails: userDetails1,
      }));
      updatewatchScreenInfo((prev) => ({
        ...prev,
        boostersList: userDetails1?.boosters,
        totalReward: userDetails1?.balanceRewards,
        tapPoints: 0,
        booster: false,
        boosterSec: 0,
        boosterPoints: 0,
        boosterDetails: {},
        watchSec: 0,
      }));
    }
    return userDetails;
  };
  const IsPointsReach =
    watchScreen?.LoginMessage ==
    "You have already reached the maximum rewards limit"
      ? true
      : false;
  const GamesFilterData = IsPointsReach
    ? gamesList?.filter((el) => el?.ref !== "Pickaword")
    : gamesList;
  return (
    <>
      <div className="games_container">
        <img
          onClick={() => {
            reclaimUserDetails();
          }}
          src="https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg"
          className="cancel-imgpoints"
          style={{ cursor: "pointer" }}
        />
        <h1 className="games_header">GAMES</h1>
        <div className="games_grid_border">
          <div
            className="fixedheight"
            ref={scrollContainerRef}
            style={{
              maxHeight: "45vh",
              overflowY: "scroll",
              WebkitOverflowScrolling: "touch",
              position: "relative",
              zIndex: 10,
              paddingBottom: "5px",
            }}
          >
            <div className="games_banner">
              <div className="games_bannerBackground"></div>
              <div className="games_bannerContent">
                {!IsPointsReach ? (
                  <div className="games_bannerText">
                    <div className="games_getUpTo">GET UP TO</div>
                    <div className="games_points">1,00,000</div>
                    <div className="games_pointsText">TOKENS DAILY IN</div>
                    <div className="games_gamesText">GAMES</div>
                  </div>
                ) : (
                  <div className="games_bannerText">
                    <div className="games_getUpTo">GAME ON,</div>
                    {/* <div className="games_points">1,00,000</div> */}
                    <div className="games_pointsText">PLAY FOR FUN</div>
                    <div className="games_gamesText">NOT FOR TOKENS</div>
                  </div>
                )}
                <div></div>
                <img
                  src="https://d1ccopf5cw1hft.cloudfront.net/s3data/gamesTv.png"
                  alt="Game character"
                  height={100}
                  className="games_bannerImage"
                />
              </div>
            </div>
            <div className="games_grid" style={{ paddingBottom: "8px" }}>
              {" "}
              {/* Add padding to the grid */}
              {GamesFilterData?.map((game) => (
                // Game buttons remain the same
                <button
                  onClick={() => {
                    const selected = gameRefMap[game?.ref];
                    if (selected) {
                      goToThePage(selected.component, selected.label);
                    }
                  }}
                  key={game.id}
                  className="games_gameCard"
                  style={{
                    backgroundImage: `url(${game.image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                  }}
                >
                  {/* <div className="games_overlay"></div>
                  <div className="games_quizText">{game?.name}</div> */}
                </button>
              ))}
            </div>
          </div>
          {/* <div
            style={{
              background: "linear-gradient(180deg, #2A2A2A 0%, #1E1E1E 100%)",
              padding: "10px 0px",
              borderRadius: "10px",
              margin: "7px",
            }}
          >
            <h4
              style={{
                fontSize: "16px", 
                textAlign: "center",
                padding: "20px 0px",
                color: "white",
              }}
              className="more_games"
            >
              More games are coming soon...!
            </h4>
          </div> */}
        </div>
      </div>
    </>
  );
};
export default Task;